// extracted by mini-css-extract-plugin
module.exports = {"commentItem":"commentItem--HcVL8"};